import React, { useEffect } from 'react'
import { DomiciliationsList, MailsWrapper } from './styles'
import Mail from 'globals/models/Mail'
import ListByDomiciliation from './ListByDomiciliation'

interface IProps {
  userMailsByDomiciliation: any,
  totalCount: number,
  defaultChecked?: boolean,
  onMailClicked: (mail: Mail) => void,
  scrollLoader?: any,
  alwaysHideCheckboxes?: boolean,
  quickAction?: string,
  quickActionCallback?: any,
  lineStyle?: string,
  selectedMailsIds: React.Key[],
  setSelectedMailsIds: (ids: React.Key[]) => void,
}

const SelectList = (props: IProps) => {
  useEffect(() => {
    if (!!props.defaultChecked) {
      const userMailIds = props.userMailsByDomiciliation.flatMap((mails: any) =>
        mails.userMails.map((userMail: any) =>
          userMail.id
        )
      )
      props.setSelectedMailsIds(userMailIds)
    }
  }, [])

  return (
    <MailsWrapper>
      <DomiciliationsList>
        <ListByDomiciliation
          selectedMailsIds={props.selectedMailsIds}
          setSelectedMailsIds={props.setSelectedMailsIds}
          userMailsByDomiciliation={props.userMailsByDomiciliation}
          totalCount={props.totalCount}
          onMailClicked={props.onMailClicked}
          scrollLoader={props.scrollLoader}
          alwaysHideCheckboxes={!!props.alwaysHideCheckboxes}
          quickAction={props.quickAction}
          quickActionCallback={props.quickActionCallback}
          lineStyle={props.lineStyle}
        />
      </DomiciliationsList>
    </MailsWrapper>
  )
}

export default SelectList
